<template>
  <div>
    <menu-panel raiz="/panel/" :vistas="Vistas" @on-log-out="logOut()" />
    <router-view></router-view>
  </div>
</template>

<script>
import MenuPanel from "../../components/panel/MenuPanel.vue";

import { RouteNames } from "../../routes/admin.routes.js";
import { VistasMenuPanel } from "../../routes/admin.routes.js";

export default {
  components: {
    MenuPanel
  },
  computed: {
    Vistas() {
      return VistasMenuPanel;
    }
  },
  methods: {
    cleanAuthData() {
      localStorage.removeItem("adminUser");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
    logOut() {
      try {
        this.cleanAuthData();
      } catch (error) {
        console.error(error);
      }

      this.$router.push({ name: RouteNames.logIn });
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/styles.scss";
</style>    